import * as React from 'react';
import { LeadingContentMenuItemDefinition } from './AmorgMenuTypes';
import { StyledToolTip } from './helpers/StyledTooltip';
import { BaseButton } from './helpers/BaseButton';
import { LeadingContent } from './contentTypes/LeadingContent';
import { PrimaryContent } from './contentTypes/PrimaryContent';
import { Flex } from '../compositeComponents/FlexHelpers';


type PropsWithoutType = Omit<LeadingContentMenuItemDefinition, "type">;

export function LeadingContentMenuItem(props:PropsWithoutType)
    :JSX.Element
{
    const [isHovering, setIsHovering] = React.useState(false);

    return (
        <BaseButton 
            selected={props.selectedState || false}
            styleVariant={props.styleVariant}
            isHovering={props.onClick && isHovering}
            onClick={props.onClick} 
            onMouseEnter={() => setIsHovering(true)}
            onMouseLeave={() => setIsHovering(false)} >

            <Flex alignItems="flex-start">

                <LeadingContent {...props.leadingContent} onClick={props.onClick} isHovering={isHovering} styleVariant={props.styleVariant} />

                <PrimaryContent {...props.primaryContent} onClick={props.onClick} isHovering={isHovering} styleVariant={props.styleVariant} />

            </Flex>
            
            {/* should go into BaseButton */}
            {props.toolTip && isHovering &&
                <StyledToolTip>{props.toolTip}</StyledToolTip>
            }

        </BaseButton>
    );
}
